/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Clear_Dark_Yak_PlotInputs */

const en_clear_dark_yak_plot = /** @type {(inputs: Clear_Dark_Yak_PlotInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Success (${i?.count})`)
};

const de_clear_dark_yak_plot = /** @type {(inputs: Clear_Dark_Yak_PlotInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Erfolgreich (${i?.count})`)
};

/**
* | output |
* | --- |
* | "Success ({count})" |
*
* @param {Clear_Dark_Yak_PlotInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const clear_dark_yak_plot = /** @type {((inputs: Clear_Dark_Yak_PlotInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clear_Dark_Yak_PlotInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clear_dark_yak_plot(inputs)
	return de_clear_dark_yak_plot(inputs)
});